module.exports = __webpack_public_path__ + "media/shared/images/waiting-ae71f6714df39bf0b3977c9a090a8bfc.gif";